import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

export const fetchRoles = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
            `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/role-management/roles`,
            {
                headers: {
                    ...commonRequestHeaders(),
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching Roles:", error);
        throw error;
    }
};

export const addRole = async (roleName) => {
    const token = localStorage.getItem("token");

    // Normalize to an array of trimmed non-empty strings
    const rolesArray = Array.isArray(roleName) ? roleName : [roleName];

    if (rolesArray.length === 0) {
        throw new Error("role name is required");
    }

    const res = await axios.post(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/role-management/role`,
        rolesArray, // <-- RAW ARRAY of strings
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return typeof res.data === "undefined" ? null : res.data;
};

export const updateRole = async (roleId, newRoleName) => {
    const token = localStorage.getItem("token");

    const value = (newRoleName ?? "").trim();
    if (!value) {
        throw new Error("role name is required");
    }

    const res = await axios.patch(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/role-management/${encodeURIComponent(roleId)}`,
        value,
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
                "Content-Type": "text/plain; charset=utf-8", // <-- key change
            },
        }
    );

    return typeof res.data === "undefined" ? null : res.data;
};

export const deleteRole = async (roleId) => {
    const token = localStorage.getItem("token");

    const res = await axios.delete(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/role-management/${encodeURIComponent(roleId)}`,
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return res?.data ?? null;
};

export const getUsageCountForRole = async (roleName) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
            `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/role-management/users-number`,
            {
                headers: {
                    ...commonRequestHeaders(),
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    roleName: roleName
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching Roles:", error);
        throw error;
    }
};
